export class Solicitante{

  constructor(
    public nombre: string,
    public email: string,
    public telefono: string,
    public idusuario?: string,
    public _id?: string,
    public numerotickepago?: string,
    public procesado?: boolean,
    public prioridad?: number,
    public nombrearchivo?: string,
    public numeroperacion?: string,
    public seleccionado?: string,
    public nombrearchivopdf?: string,
    public solicitudhtml?: string,
    public enviadoporemail?: boolean,
    public numeroconfirmacion?: string,
    public procesarSolicitud?: boolean,
    public idempresa?: string,
    public deprecompra?: boolean,
    public idultimoinventario?: string,
    public color?: string,
    public vienedemodulo?: string,
    public cveusermx?: string,
    public usermx?: string,
    public loteasignado?: number,
    public emailbarco?: string,
  ) {}

}


